var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.336,
    height: 28.485,
    viewBox: "0 0 28.336 28.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.496,
    x2: 0.5,
    y2: 1.276,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.377,
    y1: 1.116,
    x2: 0.5,
    y2: 0.566,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#ecdd97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#9a7a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.768,
    y1: 1.159,
    x2: 0.383,
    y2: 0.277,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.053,
    y1: -0.278,
    x2: 0.293,
    y2: 1.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#947025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#b1914e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd9e5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.737,
    y1: -0.123,
    x2: 0.308,
    y2: 1.188,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.682,
    y1: -0.274,
    x2: 0.39,
    y2: 1.446,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.721,
    y1: -0.275,
    x2: 0.397,
    y2: 0.997,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.708,
    y1: -0.281,
    x2: 0.287,
    y2: 1.029,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.685,
    y1: -0.158,
    x2: 0.112,
    y2: 1.098,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.79,
    y1: -0.179,
    x2: 0.053,
    y2: 1.2,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.968,
    y1: -0.246,
    x2: 0.299,
    y2: 1.253,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.895,
    y1: -0.336,
    x2: 0.361,
    y2: 1.211,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.712,
    y1: -0.431,
    x2: 0.315,
    y2: 1.149,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.635,
    y1: -0.533,
    x2: 0.32,
    y2: 1.155,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.566,
    y1: -0.229,
    x2: 0.323,
    y2: 1.145,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.608,
    y1: -0.059,
    x2: 0.305,
    y2: 1.164,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.683,
    y1: -0.273,
    x2: 0.452,
    y2: 1.102,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.679,
    y1: -0.247,
    x2: 0.275,
    y2: 1.309,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.689,
    y1: -0.425,
    x2: 0.147,
    y2: 1.249,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.765,
    y1: -0.365,
    x2: 0.124,
    y2: 1.136,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.914,
    y1: -0.185,
    x2: 0.367,
    y2: 1.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.748,
    y1: 1.024,
    x2: 0.402,
    y2: 0.222,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#fff8b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#f6eda6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#e0d289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bda659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#8c6a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#7a5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#916806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#b38710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#cc9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#daab1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0b01d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.5,
    y1: 1.204,
    x2: 0.5,
    y2: 0.331,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.5,
    y1: 0.02,
    x2: 0.5,
    y2: 0.957,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd9e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#98752b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a5300"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8193",
    "data-name": "Group 8193",
    transform: "translate(-854.658 -787.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8171",
    "data-name": "Group 8171",
    transform: "translate(854.658 787.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69788",
    "data-name": "Path 69788",
    d: "M104.026,125.466c0-.738,1.015-1.357,2.342-1.481a14.143,14.143,0,0,0-.344-1.972c-1.286.335-2.448.1-2.7-.594s.489-1.622,1.694-2.194a14.013,14.013,0,0,0-1-1.736c-1.095.756-2.268.934-2.744.368s-.093-1.692.843-2.64a14.61,14.61,0,0,0-1.53-1.291c-.772,1.087-1.813,1.653-2.453,1.281s-.668-1.556-.113-2.769a13.986,13.986,0,0,0-1.879-.687c-.353,1.283-1.134,2.175-1.862,2.046s-1.162-1.234-1.054-2.561c-.339-.023-.681-.038-1.024-.038s-.655.011-.977.036c.1,1.324-.326,2.425-1.054,2.556s-1.514-.766-1.865-2.054a14.408,14.408,0,0,0-1.884.682c.555,1.213.525,2.4-.115,2.767s-1.682-.2-2.453-1.285a14.23,14.23,0,0,0-1.537,1.285c.936.947,1.314,2.067.839,2.638s-1.651.385-2.748-.371a14.175,14.175,0,0,0-1,1.73c1.2.571,1.946,1.5,1.69,2.193s-1.419.929-2.708.591a13.842,13.842,0,0,0-.349,1.972c1.325.128,2.337.745,2.337,1.484s-1.015,1.357-2.342,1.479a14.221,14.221,0,0,0,.342,1.972c1.289-.337,2.451-.1,2.7.589s-.489,1.625-1.7,2.2a14.343,14.343,0,0,0,1,1.736c1.1-.756,2.266-.938,2.743-.37s.1,1.692-.839,2.639a14.37,14.37,0,0,0,1.527,1.291c.772-1.087,1.813-1.653,2.455-1.283s.668,1.558.111,2.772a14.535,14.535,0,0,0,1.879.687c.355-1.286,1.139-2.173,1.867-2.047s1.159,1.234,1.052,2.561c.339.025.677.038,1.023.038.329,0,.656-.013.979-.034-.1-1.325.326-2.428,1.054-2.556s1.51.763,1.864,2.05a14.03,14.03,0,0,0,1.884-.682c-.556-1.209-.53-2.392.115-2.764s1.679.2,2.453,1.285a14.383,14.383,0,0,0,1.533-1.285c-.934-.947-1.309-2.07-.835-2.633s1.649-.391,2.746.367a14.858,14.858,0,0,0,1-1.731c-1.2-.571-1.942-1.494-1.692-2.19s1.42-.931,2.71-.594a14.662,14.662,0,0,0,.349-1.97C105.038,126.821,104.026,126.2,104.026,125.466Zm-2.752-2.312a3.136,3.136,0,0,1-4.644-.039,5.051,5.051,0,0,0-2.1-2.106,3.134,3.134,0,0,1-.034-4.647A9.4,9.4,0,0,1,101.274,123.154Zm-11.363,2.288a2.289,2.289,0,1,1,2.289,2.289A2.29,2.29,0,0,1,89.911,125.441Zm-.013-9.092a3.139,3.139,0,0,1-.023,4.66,5.042,5.042,0,0,0-2.106,2.1,3.146,3.146,0,0,1-4.7-.008A9.411,9.411,0,0,1,89.9,116.349Zm-6.837,11.435a3.149,3.149,0,0,1,4.708-.018,5.02,5.02,0,0,0,2.106,2.1,3.151,3.151,0,0,1-.018,4.708A9.4,9.4,0,0,1,83.061,127.785Zm11.47,6.781a3.151,3.151,0,0,1-.007-4.7,5,5,0,0,0,2.106-2.1,3.137,3.137,0,0,1,4.656-.028A9.411,9.411,0,0,1,94.53,134.566Z",
    transform: "translate(-78.032 -111.198)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69789",
    "data-name": "Path 69789",
    d: "M88.436,119.414l.054.028a4.7,4.7,0,0,1,1.965,1.965l.028.052.046.039a3.474,3.474,0,0,0,5.086.041l.154-.133-.049-.2a9.713,9.713,0,0,0-7.025-7.033l-.2-.051-.136.154a3.476,3.476,0,0,0,.034,5.091Zm.175-4.916a9.4,9.4,0,0,1,6.783,6.793,3.136,3.136,0,0,1-4.644-.039,5.051,5.051,0,0,0-2.1-2.106A3.134,3.134,0,0,1,88.611,114.5Z",
    transform: "translate(-72.152 -109.335)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69790",
    "data-name": "Path 69790",
    d: "M86.176,121.5l.046-.041.028-.052a4.7,4.7,0,0,1,1.964-1.965l.054-.026.039-.046a3.481,3.481,0,0,0,.025-5.1l-.134-.151-.2.049a9.706,9.706,0,0,0-7.066,7l-.051.193.151.136A3.487,3.487,0,0,0,86.176,121.5Zm1.906-7.014a3.139,3.139,0,0,1-.023,4.66,5.042,5.042,0,0,0-2.106,2.1,3.146,3.146,0,0,1-4.7-.008A9.411,9.411,0,0,1,88.083,114.49Z",
    transform: "translate(-76.217 -109.339)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69791",
    "data-name": "Path 69791",
    d: "M96.388,119.518c-.046-.44-.113-.874-.2-1.3l-.331.07c.062.313.116.628.155.941-1.371.218-2.3.92-2.3,1.771s.928,1.55,2.3,1.767c-.016.129-.038.257-.057.386l.331.031c.036-.236.074-.466.1-.705-1.325-.124-2.337-.741-2.337-1.479S95.061,119.642,96.388,119.518Z",
    transform: "translate(-68.052 -106.731)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69792",
    "data-name": "Path 69792",
    d: "M92.818,113.97c-.913,1.049-1.177,2.181-.63,2.836s1.712.592,2.9-.124c.067.106.129.214.195.322l.306-.133c-.131-.219-.262-.437-.4-.648-1.095.756-2.268.934-2.744.368s-.093-1.692.843-2.64c-.277-.268-.568-.52-.864-.766l-.231.241C92.4,113.6,92.615,113.782,92.818,113.97Z",
    transform: "translate(-69.203 -109.933)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69793",
    "data-name": "Path 69793",
    d: "M86.764,129.747c.329,0,.656-.013.979-.034-.1-1.325.326-2.428,1.054-2.556s1.51.763,1.864,2.05q.528-.15,1.037-.342l-.065-.332c-.249.093-.5.182-.753.26-.45-1.314-1.3-2.113-2.14-1.964s-1.368,1.183-1.345,2.569c-.209.01-.422.013-.63.013-.061,0-.121,0-.182,0l-.01.337Z",
    transform: "translate(-72.597 -101.262)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69794",
    "data-name": "Path 69794",
    d: "M81.823,127.611c.772-1.087,1.813-1.653,2.455-1.283s.668,1.558.111,2.772c.154.069.311.128.466.19l.177-.285c-.07-.028-.141-.052-.209-.082.5-1.3.358-2.459-.381-2.883s-1.807.028-2.68,1.1c-.139-.1-.275-.216-.409-.329l-.191.273C81.378,127.268,81.6,127.444,81.823,127.611Z",
    transform: "translate(-76.041 -101.854)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69795",
    "data-name": "Path 69795",
    d: "M79.655,125.165c1.1-.756,2.266-.938,2.743-.37s.1,1.692-.839,2.639c.277.27.566.525.864.769l.191-.273c-.2-.165-.4-.334-.589-.511.911-1.047,1.173-2.183.628-2.838s-1.71-.592-2.9.121c-.095-.147-.185-.3-.275-.452l-.3.146C79.329,124.658,79.486,124.915,79.655,125.165Z",
    transform: "translate(-77.303 -102.969)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69796",
    "data-name": "Path 69796",
    d: "M78.343,122.546c1.289-.337,2.451-.1,2.7.589s-.489,1.625-1.7,2.2c.16.331.337.653.522.969l.3-.146c-.133-.224-.259-.448-.376-.677,1.216-.673,1.852-1.653,1.56-2.455s-1.4-1.141-2.764-.874c-.075-.334-.133-.671-.183-1.01l-.331.072Q78.182,121.888,78.343,122.546Z",
    transform: "translate(-78.001 -104.872)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69797",
    "data-name": "Path 69797",
    d: "M78.037,119.46c1.325.128,2.337.745,2.337,1.484s-1.015,1.357-2.342,1.479c.021.214.051.425.08.637l.331-.072c-.013-.093-.028-.185-.039-.275,1.37-.216,2.3-.918,2.3-1.769s-.929-1.555-2.3-1.771c.033-.265.079-.53.128-.794l-.316-.147C78.143,118.637,78.079,119.046,78.037,119.46Z",
    transform: "translate(-78.032 -106.721)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69798",
    "data-name": "Path 69798",
    d: "M79.33,116.556c1.2.571,1.946,1.5,1.69,2.193s-1.419.929-2.708.591c-.062.247-.115.5-.165.745l.316.147c.031-.165.062-.331.1-.493,1.363.268,2.479-.074,2.772-.877s-.34-1.777-1.556-2.448c.157-.3.332-.6.512-.9l-.268-.191C79.774,115.724,79.538,116.132,79.33,116.556Z",
    transform: "translate(-77.959 -108.572)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69799",
    "data-name": "Path 69799",
    d: "M81.514,113.984c.936.947,1.314,2.067.839,2.638s-1.651.385-2.748-.371c-.11.16-.211.332-.314.5l.268.191c.049-.077.1-.157.146-.234,1.19.718,2.353.781,2.9.128s.285-1.789-.623-2.831c.247-.229.5-.445.766-.653l-.2-.263C82.193,113.372,81.845,113.666,81.514,113.984Z",
    transform: "translate(-77.23 -109.996)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69800",
    "data-name": "Path 69800",
    d: "M84.351,112.11c.555,1.213.525,2.4-.115,2.767s-1.682-.2-2.453-1.285c-.172.123-.334.257-.5.388l.2.263c.079-.062.155-.126.236-.187.872,1.08,1.946,1.535,2.684,1.109s.88-1.581.381-2.877c.262-.11.527-.206.794-.3l-.128-.308C85.079,111.812,84.709,111.951,84.351,112.11Z",
    transform: "translate(-75.962 -110.889)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69801",
    "data-name": "Path 69801",
    d: "M87.533,111.233c.1,1.324-.326,2.425-1.054,2.556s-1.514-.766-1.865-2.054c-.265.077-.525.164-.784.255l.128.308c.146-.049.29-.1.437-.147.45,1.314,1.3,2.111,2.14,1.965s1.366-1.185,1.345-2.569c.2-.01.4-.016.6-.016l-.02-.332C88.15,111.2,87.839,111.21,87.533,111.233Z",
    transform: "translate(-74.342 -111.197)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69802",
    "data-name": "Path 69802",
    d: "M90.65,111.751c-.353,1.283-1.134,2.175-1.862,2.046s-1.162-1.234-1.054-2.561c-.339-.023-.681-.038-1.024-.038l-.049,0,.02.332.029,0c.221,0,.448.008.676.02-.025,1.389.5,2.428,1.343,2.574s1.689-.645,2.139-1.957c.2.061.4.129.592.2l.126-.309C91.276,111.944,90.965,111.843,90.65,111.751Z",
    transform: "translate(-72.541 -111.198)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69803",
    "data-name": "Path 69803",
    d: "M93.227,113.592c-.772,1.087-1.813,1.653-2.453,1.281s-.668-1.556-.113-2.769c-.308-.139-.623-.265-.943-.381l-.126.309c.214.079.425.16.635.249-.5,1.3-.358,2.456.383,2.882s1.8-.026,2.68-1.106c.126.1.249.2.371.3l.231-.241C93.676,113.937,93.455,113.76,93.227,113.592Z",
    transform: "translate(-70.675 -110.864)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69804",
    "data-name": "Path 69804",
    d: "M84.83,129.2c.355-1.286,1.139-2.173,1.867-2.047s1.159,1.234,1.052,2.561c.275.021.553.031.831.036l.01-.337c-.165,0-.329,0-.494-.011.026-1.391-.5-2.43-1.342-2.576s-1.69.65-2.142,1.959c-.342-.11-.684-.232-1.018-.367l-.177.285A14.417,14.417,0,0,0,84.83,129.2Z",
    transform: "translate(-74.604 -101.265)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69805",
    "data-name": "Path 69805",
    d: "M93.206,127.163c-.872-1.078-1.944-1.535-2.682-1.111s-.88,1.582-.385,2.88c-.157.065-.314.124-.475.183l.065.332c.286-.1.569-.216.846-.34-.556-1.209-.53-2.392.115-2.764s1.679.2,2.453,1.285c.195-.142.383-.3.573-.447l-.188-.275C93.422,126.991,93.316,127.08,93.206,127.163Z",
    transform: "translate(-70.629 -101.845)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69806",
    "data-name": "Path 69806",
    d: "M95.175,125.233c.216-.321.416-.653.609-.99l-.291-.164c-.133.237-.27.47-.417.7-1.19-.718-2.353-.779-2.9-.124s-.285,1.785.623,2.831c-.216.2-.447.393-.679.581l.188.275c.332-.267.655-.542.961-.838-.934-.947-1.309-2.07-.835-2.633S94.078,124.475,95.175,125.233Z",
    transform: "translate(-69.215 -103.001)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69807",
    "data-name": "Path 69807",
    d: "M96.334,122.529c.1-.414.182-.838.249-1.265l-.331-.031c-.047.3-.1.6-.17.9-1.361-.265-2.479.075-2.77.877s.345,1.777,1.555,2.45c-.074.146-.155.29-.237.434l.291.164c.137-.245.272-.489.4-.741-1.2-.571-1.942-1.494-1.692-2.189S95.045,122.192,96.334,122.529Z",
    transform: "translate(-68.352 -104.812)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69808",
    "data-name": "Path 69808",
    d: "M94.883,116.384c-1.216.671-1.852,1.649-1.561,2.453s1.4,1.139,2.766.875c.025.113.046.227.067.344l.331-.07c-.044-.226-.092-.45-.147-.671-1.286.335-2.448.1-2.7-.594s.489-1.622,1.694-2.194c-.182-.373-.385-.735-.6-1.088l-.306.133C94.586,115.837,94.741,116.107,94.883,116.384Z",
    transform: "translate(-68.346 -108.5)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69809",
    "data-name": "Path 69809",
    d: "M90.529,121.609l-.046.039-.026.056a4.707,4.707,0,0,1-1.967,1.965l-.054.026-.039.046a3.486,3.486,0,0,0,.007,5.137l.136.152.195-.051a9.711,9.711,0,0,0,7-7.069l.051-.2-.154-.133A3.48,3.48,0,0,0,90.529,121.609Zm-1.879,7.048a3.151,3.151,0,0,1-.007-4.7,5,5,0,0,0,2.106-2.1,3.137,3.137,0,0,1,4.656-.028A9.411,9.411,0,0,1,88.65,128.657Z",
    transform: "translate(-72.152 -105.289)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69810",
    "data-name": "Path 69810",
    d: "M90.333,120.922A2.628,2.628,0,0,0,87.71,118.3a2.622,2.622,0,1,0,2.623,2.623Zm-2.623,2.289A2.289,2.289,0,1,1,90,120.922,2.289,2.289,0,0,1,87.71,123.211Z",
    transform: "translate(-73.542 -106.679)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69811",
    "data-name": "Path 69811",
    d: "M88.271,123.695l-.054-.026a4.681,4.681,0,0,1-1.964-1.965l-.028-.056-.046-.039a3.491,3.491,0,0,0-5.153.021l-.149.136.047.193a9.714,9.714,0,0,0,7.038,7.032l.195.049.133-.149a3.486,3.486,0,0,0,.02-5.15Zm-.226,4.973a9.4,9.4,0,0,1-6.8-6.793,3.149,3.149,0,0,1,4.708-.018,5.02,5.02,0,0,0,2.106,2.1A3.151,3.151,0,0,1,88.045,128.668Z",
    transform: "translate(-76.221 -105.289)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69812",
    "data-name": "Path 69812",
    d: "M82.753,135.649c.038-.044-.466.015-.466.015h0a14.37,14.37,0,0,0,1.527,1.291h0s-.026-.511-.062-.466C83.406,136.225,83.074,135.944,82.753,135.649Zm3.667-23.227s.455.231.434.177c.4-.169.813-.319,1.231-.447.016.054.219-.414.219-.414a14.315,14.315,0,0,0-1.884.681Zm-8.035,9.543a13.553,13.553,0,0,0-.347,1.97s.422-.275.37-.285c.056-.43.131-.862.226-1.286.057.008-.247-.4-.247-.4Zm26.161,9.877c-.2.388-.419.764-.655,1.129-.047-.029.1.457.1.457a14.387,14.387,0,0,0,1-1.73h0S104.5,131.815,104.547,131.843Zm-.628-13.9q.351.552.651,1.136c-.049.026.447.141.447.141a13.973,13.973,0,0,0-1-1.733S103.867,117.976,103.918,117.946Zm2.072,9.287a12.893,12.893,0,0,1-.227,1.283c-.056-.01.252.4.252.4a14.662,14.662,0,0,0,.349-1.97h0S105.934,127.225,105.99,127.233Zm-8.447,11.052c-.4.167-.813.314-1.227.443-.02-.054-.219.414-.219.414a14.259,14.259,0,0,0,1.884-.682l0,0S97.523,138.23,97.543,138.285Zm4.068-2.607c-.319.295-.656.574-1,.838-.034-.041-.062.463-.062.463a14.025,14.025,0,0,0,1.533-1.283h0S101.573,135.634,101.611,135.678ZM78.4,127.191c.056-.01-.37-.29-.37-.29h0a14.263,14.263,0,0,0,.342,1.972s.308-.411.252-.4C78.531,128.051,78.456,127.621,78.4,127.191Zm9.637,11.525c-.414-.131-.825-.28-1.227-.448.021-.056-.434.172-.434.172v0a14.446,14.446,0,0,0,1.879.687S88.06,138.66,88.04,138.716ZM79.83,131.8c.049-.029-.447-.146-.447-.146a13.987,13.987,0,0,0,1,1.735s.147-.486.1-.46C80.248,132.566,80.028,132.188,79.83,131.8Zm20.818-17.413c.344.268.677.547,1,.844-.038.041.465-.02.465-.02a14.231,14.231,0,0,0-1.527-1.289S100.611,114.436,100.649,114.391ZM106,123.7c-.054.01.371.285.371.285a14.158,14.158,0,0,0-.344-1.967h0s-.306.407-.249.4C105.867,122.834,105.942,123.265,106,123.7ZM92.83,139.334c-.209.01-.422.013-.63.013-.226,0-.45,0-.676-.015,0-.057-.347.313-.347.313.339.025.677.038,1.023.038.329,0,.655-.013.977-.034C93.177,139.648,92.83,139.277,92.83,139.334Zm3.469-27.01a1.636,1.636,0,0,0,.059-.157c.416.129.826.28,1.227.448-.021.054-.038.108-.057.16l.491-.335v0a13.986,13.986,0,0,0-1.879-.687Zm-5.076-1.09s.349.371.347.314c.211-.01.422-.018.63-.018s.448.008.676.02c0,.056.347-.314.347-.314-.34-.023-.679-.038-1.023-.038S91.545,111.209,91.223,111.234ZM79.4,119.182s.5-.113.447-.142c.2-.386.421-.764.658-1.131.047.028-.1-.455-.1-.455A14.357,14.357,0,0,0,79.4,119.182Zm2.914-4s.506.061.47.021a12.821,12.821,0,0,1,1-.839c.034.043.062-.465.062-.465A14.534,14.534,0,0,0,82.318,115.184Z",
    transform: "translate(-78.032 -111.198)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(858.689 791.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81129",
    "data-name": "Path 81129",
    d: "M4.2-7.773a.9.9,0,0,1-.354-.449A2.526,2.526,0,0,1,3.7-8.9a3.8,3.8,0,0,1-.052-.657.8.8,0,0,1,.017-.155v-.881q0-.985.009-1.486a1.248,1.248,0,0,1,.251-.795q.035-.035.155-.13a.287.287,0,0,0,.121-.233.368.368,0,0,0-.035-.19.132.132,0,0,0-.1-.06.907.907,0,0,1-.121-.026.221.221,0,0,1-.112-.086,1.281,1.281,0,0,1-.19-.622,4.222,4.222,0,0,1-.052-.691.8.8,0,0,1,.017-.155q0-.449.026-.907t.026-.821q0-.777.052-1.486v-.449a4.147,4.147,0,0,0-.052-.708.213.213,0,0,0-.035-.086H3.611a.07.07,0,0,0-.052.017.2.2,0,0,0-.052.035l-.035.035a.326.326,0,0,0-.1-.017.535.535,0,0,0-.294.1,2.742,2.742,0,0,1-.518.276.153.153,0,0,1-.069.017.07.07,0,0,1-.052-.017H2.3a.354.354,0,0,0-.1.1.354.354,0,0,1-.1.1q-.225.086-.4.138l-.337.1q-.164.052-.337.121t-.38.173a.838.838,0,0,1-.346.086.414.414,0,0,0-.294.1L0-18.139q0,.035.052.052A.133.133,0,0,0,.1-18.07a1.011,1.011,0,0,0,.035.346q.035.069.086.069H.242a.7.7,0,0,0,.173-.078.471.471,0,0,1,.242-.06l.259.035q.086.017.173.026a.21.21,0,0,1,.1.026.533.533,0,0,1,.181.225,1.746,1.746,0,0,1,.1.276,1.6,1.6,0,0,1,.017.225v.069a1.833,1.833,0,0,0-.017.207v.069A.246.246,0,0,0,1.5-16.5a.31.31,0,0,1,.052.155v.276q0,.346-.017.622-.052.4-.069.743a1.572,1.572,0,0,0,.052.415.953.953,0,0,1,.035.19v.035a.856.856,0,0,1-.2.311,3.844,3.844,0,0,0-.259.3.836.836,0,0,0-.147.268v.035q0,.1.155.173l.1.043a.4.4,0,0,1,.069.06q.138.121.147.19a.936.936,0,0,0,.043.173,1.737,1.737,0,0,1,.086.484v.207q0,.207-.017.432-.017.346-.043.717t-.026.717a3.529,3.529,0,0,0,.069.726,2.172,2.172,0,0,1,.035.346.971.971,0,0,1-.017.19,1.343,1.343,0,0,1-.406.665,2.577,2.577,0,0,1-.6.441.544.544,0,0,1-.207.052,1.22,1.22,0,0,0-.164.009.088.088,0,0,0-.078.06.192.192,0,0,0-.017.086A1.039,1.039,0,0,0,.1-7.22a.2.2,0,0,0,.112.164.516.516,0,0,0,.216.043,1.109,1.109,0,0,0,.2-.017,1.079,1.079,0,0,1,.112-.017.168.168,0,0,1,.086.035.133.133,0,0,1,.017.052.015.015,0,0,1-.017.017q.207-.035.449-.052h.466l.441.035q.216.017.371.017A8.528,8.528,0,0,0,3.516-7a9.385,9.385,0,0,1,1.045-.052.966.966,0,0,1,.259.026A.51.51,0,0,0,4.959-7a.14.14,0,0,0,.086-.026.268.268,0,0,0,.069-.112.676.676,0,0,0,.052-.225.213.213,0,0,0-.035-.121.435.435,0,0,0-.259-.138,3.437,3.437,0,0,0-.363-.052A.623.623,0,0,1,4.2-7.773ZM3.11-13.059q-.1,0-.1-.069a.117.117,0,0,1,.035-.086.05.05,0,0,1,.035-.017H3.11a.1.1,0,0,1,.017.069.473.473,0,0,1-.017.1q.069,0,.069.035v.017l-.017.017Q3.127-12.99,3.11-13.059Zm-.276,2.471q0-.1.069-.1H2.92q0-.069.035-.069h.017l.017.017q0,.035-.069.052,0,.1-.069.1H2.833v.035q0,.035-.017.035L2.8-10.537a.015.015,0,0,1-.017-.017Q2.782-10.572,2.833-10.589ZM2.92-12.23a.05.05,0,0,1,.017.035.05.05,0,0,1-.017.035.153.153,0,0,1-.069.017H2.833a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017A.015.015,0,0,1,2.92-12.23Zm0,.363v-.017q0-.035.069-.069a.473.473,0,0,1,.1-.017H3.11l.017.017q0,.035-.069.052a.278.278,0,0,1-.121.035Zm0-.829q.017-.052.052-.052l.017.017a.117.117,0,0,0,.086.035H3.11q-.017.086-.086.086A.1.1,0,0,1,2.92-12.7Zm.19-5.01q0,.069-.017.069a.015.015,0,0,1-.017-.017q-.052-.017-.052-.052,0-.069.017-.069h.035A.1.1,0,0,1,3.11-17.707Zm-.19,2.471a.05.05,0,0,1,.017.035.05.05,0,0,1-.017.035.153.153,0,0,1-.069.017H2.833a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017A.015.015,0,0,1,2.92-15.236Zm-.812,2.9a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035H2.021A.05.05,0,0,1,2-12.265q0-.017.035-.052a.133.133,0,0,1,.052-.017Zm-.553-5.46a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017.05.05,0,0,1,.035.017.05.05,0,0,1,.017.035q0,.017-.035.035a.153.153,0,0,1-.069.017Zm.1,9.934a.05.05,0,0,1-.017-.035q0-.017.035-.052a.05.05,0,0,1,.035-.017.05.05,0,0,1,.035.017.05.05,0,0,1,.017.035q0,.017-.035.035a.133.133,0,0,1-.052.017Zm.086-2.557a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017.015.015,0,0,1,.017.017.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035A.015.015,0,0,1,1.745-10.416Zm0-1.555a.05.05,0,0,1-.017-.035q0-.017.035-.035a.133.133,0,0,1,.052-.017h.017a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035A.015.015,0,0,1,1.745-11.971Zm.173.743q-.069,0-.069-.035l.017-.017V-11.3q.035,0,.052.069h.035q.035,0,.035.017v.017a.015.015,0,0,1-.017.017Q1.952-11.176,1.918-11.228Zm.1-.466q0-.086.069-.086h.017a.148.148,0,0,1,.155-.086H2.3V-11.9q0-.035.017-.035h.017a.05.05,0,0,1,.017.035q0,.017-.052.035v.086a.1.1,0,0,1,.069.035v.017q0,.017-.069.035v.155a.07.07,0,0,1-.052.017H2.229a.167.167,0,0,1-.086-.069.186.186,0,0,1-.035-.1H2.021q0,.069-.035.069H1.97a.015.015,0,0,1-.017-.017Q1.952-11.66,2.021-11.695ZM2.3-10.14v-.035q0-.035.017-.035h.017a.05.05,0,0,1,.017.035q0,.017-.052.035,0,.069-.035.069l-.017-.017H2.229Q2.229-10.122,2.3-10.14Zm0-.916a.05.05,0,0,1,.017.035q0,.017-.035.035a.1.1,0,0,1-.069.035H2.194a.05.05,0,0,1-.017-.035q0-.017.035-.052a.153.153,0,0,1,.069-.017Zm0-.173a.05.05,0,0,1,.017.035q0,.017-.035.035a.153.153,0,0,1-.069.017H2.194a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017A.05.05,0,0,1,2.3-11.228Zm-.276,2.54A.05.05,0,0,1,2-8.723q0-.017.035-.035a.133.133,0,0,1,.052-.017h.017a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035A.015.015,0,0,1,2.021-8.688Zm0-1.261A.05.05,0,0,1,2-9.984q0-.017.035-.052a.133.133,0,0,1,.052-.017h.017a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035Zm0-.639A.05.05,0,0,1,2-10.623q0-.017.035-.052a.133.133,0,0,1,.052-.017h.017a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035Zm1,2.678H2.142a1.271,1.271,0,0,0,.052-.138.05.05,0,0,1-.017-.035q0-.035.069-.052a2.88,2.88,0,0,0,.112-.4,1.949,1.949,0,0,0,.043-.4v-1.745a.015.015,0,0,1-.017-.017.015.015,0,0,1-.017-.017q0-.017.035-.052v-.19H2.384a.05.05,0,0,1-.017-.035q0-.017.035-.052v-1.054a2.371,2.371,0,0,0-.086-.682,1.928,1.928,0,0,0-.207-.475,2.3,2.3,0,0,0,.207-.492,2.371,2.371,0,0,0,.086-.682v-2.488a1.843,1.843,0,0,0-.363-1.106l.726-.276v3.87a2.371,2.371,0,0,0,.086.682,2.3,2.3,0,0,0,.207.492,2.353,2.353,0,0,0-.164.32,1.677,1.677,0,0,0-.112.423l.035-.017a.015.015,0,0,1,.017.017.05.05,0,0,1,.017.035v.017a.1.1,0,0,1-.069.035.8.8,0,0,0-.017.155V-8.93a2,2,0,0,0,.069.518A2.637,2.637,0,0,0,3.023-7.911Zm0-3.594a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017.015.015,0,0,1,.017.017.05.05,0,0,1,.017.035q0,.017-.035.035a.133.133,0,0,1-.052.017Zm.086.812a.05.05,0,0,1-.017-.035q0-.017.035-.035a.133.133,0,0,1,.052-.017H3.2a.05.05,0,0,1,.017.035q0,.017-.035.035-.035.035-.052.035A.015.015,0,0,1,3.11-10.692ZM3.2-12.507a.3.3,0,0,1,.086.173.07.07,0,0,1-.017.052.206.206,0,0,1-.138.1H3.093q-.052,0-.069-.069a.015.015,0,0,1-.017-.017Q3.006-12.334,3.2-12.507Zm.1-5.287a.05.05,0,0,1-.017-.035q0-.017.035-.052a.05.05,0,0,1,.035-.017.05.05,0,0,1,.035.017.05.05,0,0,1,.017.035q0,.017-.035.035a.133.133,0,0,1-.052.017Zm.173,4.648a.05.05,0,0,1-.017-.035q0-.017.035-.052a.133.133,0,0,1,.052-.017.015.015,0,0,1,.017.017.05.05,0,0,1,.017.035.05.05,0,0,1-.017.035.153.153,0,0,1-.069.017ZM2.108-11.695H2.3v-.086h-.19Z",
    transform: "translate(866.496 814.6)",
    fill: "#2a2a29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.c35b4ee957f27637f76b3fb3673e6f46.svg";
export { ForwardRef as ReactComponent };